<ng-container *ngTemplateOutlet="template"></ng-container>
<sd-4-5-1-spinner></sd-4-5-1-spinner>
